(function () {
  const productsPerRow = () => {
    $(".per-row__button")
      .off("click.productsPerRow")
      .on("click.productsPerRow", function () {
        const perRow = $(this).data("per-row");
        const $wrapper = $("[data-productis-in-row]");

        // 同じ列数なら何もしない
        if ($wrapper.attr("data-productis-in-row") == perRow) return;

        $(".per-row__button").removeClass("active");
        $(`[data-per-row="${perRow}"]`).addClass("active");

        // フェードアウト
        $wrapper.addClass("is-fading");

        setTimeout(() => {
          // 2列 / 4列を切り替え
          $wrapper.attr("data-productis-in-row", perRow);

          // レイアウト変更後にフェードイン
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              $wrapper.removeClass("is-fading");
            });
          });
        }, 250);
      });
  };

  document.addEventListener("shopify:section:load", function () {
    productsPerRow();
  });

  productsPerRow();
})();